import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import { PERFILES_COMPRADOR } from '../../constants/perfiles'
import Calificar from '../calificar/Calificar'
import Carrito from '../carrito/Carrito'
import CompraDirecta from '../compraDirecta/CompraDirecta'
import Compras from '../compras/Compras'
import Comprobante from '../compras/Comprobante'
import PasarelaPago from '../compras/PasarelaPago'
import RutaProtegidaPorPerfil from '../hoc/RutaProtegidaPorPerfil'
import DetallePreguntas from '../pages/preguntas/DetallePreguntas'
import PreguntasPublicaciones from '../pages/preguntas/PreguntasPublicaciones'
import AnalisisCompra from '../pedidos/AnalisisCompra'
import Pedidos from '../pedidos/Pedidos'
import Presupuestos from '../presupuestos/Presupuestos'

const proteger = (element) => (
  <RutaProtegidaPorPerfil perfilesPermitidos={PERFILES_COMPRADOR}>{element}</RutaProtegidaPorPerfil>
)

const CompradorRoutes = (props) => (
  <>
    <Route path="/Pedidos" element={proteger(<Pedidos esVentas={false} />)} />
    <Route path="/AnalisisCompra/:idPedido" element={proteger(<AnalisisCompra />)} />
    <Route
      path="/PreguntasComprador"
      element={proteger(<PreguntasPublicaciones tipo={'comprador'} />)}
    />
    <Route
      path="/PreguntasComprador/:idPublicacion/:idVendedor"
      element={proteger(<DetallePreguntas {...props} tipo={'comprador'} />)}
    />
    <Route path="/PresupuestosComprador" element={proteger(<Presupuestos esVendedor={false} />)} />
    <Route
      path="/CalificarProducto/:idPublicacion/:idVendedor/:idPedidoItem"
      element={proteger(<Calificar />)}
    />
    <Route
      path="/CalificarVendedor/:idPublicacion/:idVendedor/:idPedidoItem"
      element={proteger(<Calificar />)}
    />
    <Route path="/Carrito" element={proteger(<Carrito />)} />
    <Route path="/Compras" element={proteger(<Compras />)} />
    <Route path="/Compras/:idPublicacion" element={proteger(<Compras />)} />
    <Route path="/PasarelaPago" element={proteger(<PasarelaPago />)} />
    <Route path="/Comprobante/:idPedido" element={proteger(<Comprobante />)} />
    <Route path="/compraDirecta" element={proteger(<CompraDirecta />)} />
  </>
)

CompradorRoutes.propTypes = {
  cambiarImagenPerfil: PropTypes.func
}

export default CompradorRoutes
